import * as React from 'react'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import LoginScreen from '../screens/Login/LoginScreen'
import WelcomeScreen from '../screens/Login/WelcomeScreen'
import ForgotPasswordScreen from '../screens/Login/ForgotPasswordScreen'
import FunnelScreen from '../screens/Login/FunnelScreen'
import PaywallScreen from '../screens/Billing/PaywallScreen'
import { Platform } from 'react-native'
import { useTranslation } from 'react-i18next'

const Stack = createNativeStackNavigator();

export default function AuthStack() {
  const { t } = useTranslation()
  return (
    <Stack.Navigator initialRouteName={Platform.OS === 'web' ? 'Login' : 'Welcome'}>
      <Stack.Screen name="Welcome" component={WelcomeScreen} options={{ title: '' }}/>
      <Stack.Screen name="Login" component={LoginScreen} options={{ title: 'ATLAS | ' + t('login.login') }}/>
      <Stack.Screen name="ForgotPassword" component={ForgotPasswordScreen} options={{ title: 'ATLAS | ' + t('login.passwordReset') }}/>
      <Stack.Screen name="Funnel" component={FunnelScreen} options={{ title: '' }} />
      <Stack.Screen name="Paywall" component={PaywallScreen} options={{ title: '' }} />
    </Stack.Navigator>
  );
}
